import { SET_LANGUAGE, SET_RESTAURANT_ID, SET_CATEGORIES, SET_ITEMS_BY_CATEGORIES, SET_RESTAURANT_NAME, SET_RESTAURANT_INFO, SET_POSTS_FEED, SET_RESTAURANT_NOT_FOUND, SET_CATEGORIES_GRAPH, SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP, SET_DISHES_LOOKUP } from '../Actions/ActionTypes';
import { authAndLoadRestaurantData } from '../../FetchAPI/fetchData';

const initialState = {
    
    language: "",
    restaurantID: "",
    restaurantName: "",

    categories: null,
    itemsByCategories: null,
    dishesLookup: null,
    restaurantInfo: null,
    restaurantNotFound: false,
    posts: null,
    categoriesGraph: null,
    dishesByCategoriesGraphLookup: null,
    hasCartUpdated: false,
}

const rootReducer = ( state = initialState, action ) => {
        
    switch ( action.type ) {
        case SET_LANGUAGE:
            return { ...state, language: action.payload.language }

        case SET_RESTAURANT_ID: {
            if( action.payload.restaurant_id )
                authAndLoadRestaurantData( action.payload.restaurant_id );
                
            return { ...state, restaurantID: action.payload.restaurant_id }
        }

        case SET_RESTAURANT_NAME:
            return { ...state, restaurantName: action.payload.restaurant_name }

        case SET_CATEGORIES: 
            return { ...state, categories: action.payload.categories }

        case SET_ITEMS_BY_CATEGORIES:
            return { ...state, itemsByCategories: action.payload.itemsByCategories }

        case SET_RESTAURANT_INFO:
            return { ...state,  restaurantInfo: action.payload.restaurantInfo}

        case SET_POSTS_FEED:
            return { ...state, posts: action.payload.posts }

        case SET_RESTAURANT_NOT_FOUND:
            return { ...state, restaurantNotFound: action.payload.restaurantNotFound }
            
        case SET_CATEGORIES_GRAPH: {
            return { ...state, categoriesGraph: action.payload.categoriesGraph }
        }

        case SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP: {
            return { ...state, dishesByCategoriesGraphLookup: action.payload.dishesByCategoriesGraphLookup }
        }

        case SET_DISHES_LOOKUP: {
            return { ...state, dishesLookup: action.payload.dishesLookup }
        }

        default:
            return state;
    }
} 

export default rootReducer;